import {_, React, observer, observable, classNames, useAsObservableSource} from '@api'
import {TabNode} from '@flexlayout'
import {RightSidebarBody, StoresInstanceContext, useVipLocalStore, VipLocalStore} from '@modules'
import {CatalogRootFlexLayoutStoreContext, FlexLayoutComponentProps, ITrackedCatalogSidebarDetailsTabSettings, StoresInstance} from '@stores'
import {autorun, runInAction} from 'mobx'
import {useEffect} from 'react'
import * as css from './FlexLayoutCatalogItemDetailsPane.css'

/// region Store

export class FlexLayoutCatalogItemDetailsPaneStore extends VipLocalStore {
  constructor(public props: MyProps, stores: StoresInstance) {
    super(stores)
  }

  get node(): TabNode<ITrackedCatalogSidebarDetailsTabSettings> { return this.props.flexNode}

  @observable.ref overriddenStores: Partial<StoresInstance>

  get tabConfig() { return this.props.flexNode.config as ITrackedCatalogSidebarDetailsTabSettings}

  @observable lastImageIndex = 0

  registerEffects = () => {
    const toDispose = [
      autorun(() => {
        this.node.extraData.store = this
      }),
      autorun(() => {
        if (this.overriddenStores?.disposed) {
          this.overriddenStores = null
          this.node.extraData.store = null
        }
      }),
      autorun(() => {
        const { props: {flexNode}, stores, stores: {flexLayout, flexLayout: {activeOrLastCatalogRootId}}, overriddenStores} = this,
          isSidebarDisposed = overriddenStores?.sidebar?.right?.isDisposed
        // trace()
        runInAction(() => {
          const {activeOrLastCatalogRoot} = flexLayout
          const ws = activeOrLastCatalogRoot?.catalog?.workspace

          this.lastImageIndex = 0
          this.overriddenStores = new StoresInstance(
            `Inline details Tab - ${flexNode.id}`,
            ws,
            flexNode.id,
            'inline-details',
            {tab: flexNode})


          //
          if (activeOrLastCatalogRoot) {
            //this.overriddenStores.sidebar = new SidebarStore(activeCatalogRoot.catalog)
            this.overriddenStores.sidebar.right.flexLocation = 'catalogItemDetails'
            this.overriddenStores.flexLayoutCatalogRoot = activeOrLastCatalogRoot
          }
        })
      })
    ]

    return () => toDispose.forEach(d => {
      d && d()

      // Intentionally don't destroy the entire store so that when closing/reopening sidebar we don't have to reload data
      // this.overriddenStores?.sidebar?.dispose()
    })
  }

  get activeCatalog() { return this.flexLayout.activeOrLastCatalogRoot?.catalog}
}

export const FlexLayoutCatalogItemDetailsPaneStoreContext = React.createContext<FlexLayoutCatalogItemDetailsPaneStore>(null)
export const useFlexLayoutCatalogItemDetailsPaneStore = () => React.useContext(FlexLayoutCatalogItemDetailsPaneStoreContext)

/// endregion

/// region Components

interface MyProps extends FlexLayoutComponentProps {
  className?: string
}

export const FlexLayoutCatalogItemDetailsPane = observer<MyProps>(function FlexLayoutCatalogItemDetailsPane({className, flexNode, ...props}) {
  const obsProps = useAsObservableSource({flexNode}),
    store = useVipLocalStore((stores) => new FlexLayoutCatalogItemDetailsPaneStore(obsProps, stores)),
    {flexLayout: {activeTab}, overriddenStores, registerEffects} = store,
    selectedPathItem = overriddenStores?.sidebar?.right?.selectedPathItem

  useEffect(() => registerEffects(), [])

  if (!activeTab) return null

  // console.log({selectedPathItem, overriddenStores, urlProcessed: overriddenStores?.catalog?.settingsStore?.urlProcessed, selectedCatalogIDs: overriddenStores?.catalog?.settings?.selectedCatalogIds})
  return (
    <FlexLayoutCatalogItemDetailsPaneStoreContext.Provider value={store}>
      <CatalogRootFlexLayoutStoreContext.Provider value={activeTab?.catalogRoot}>
        <StoresInstanceContext.Provider value={store.overriddenStores as StoresInstance}>
          <div className={classNames(css.root, className)}>
            {/*<RightSidebarHeader {...props} className={css.sidebarHeader}/>*/}
            {!overriddenStores?.catalog?.settingsStore?.urlProcessed
             ? null
             : _.isEmpty(selectedPathItem) || !selectedPathItem.where ? <div className={css.empty}>No {overriddenStores?.catalog?.catalogItemName ?? 'Item'} Selected</div>
                                 : <RightSidebarBody {...props} />}
          </div>
        </StoresInstanceContext.Provider>
      </CatalogRootFlexLayoutStoreContext.Provider>
    </FlexLayoutCatalogItemDetailsPaneStoreContext.Provider>)
})

/// endregion





// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexComponents/toolbox-items/FlexLayoutCatalogItemDetailsPane.tsx